import { useLocation } from "react-router";

export const useLocationSearch = () => {
  const location = useLocation();

  return location.search.replace(/^(\s|\?)+|(\s|\?)+$/g, "");
};
